import React from "react";
import styles from "./recommendation.module.css"
import {useNavigate} from "react-router-dom";
import RecommendationCard from "./RecommendationCard";
import {PageHeader} from "../../../components/shared/PageHeader/PageHeader";
import {useFetchRecommsShort} from "../../../hooks/useQuery/useFetchRecommsShort";
import {LoadingErrorBlock} from "../../../components/shared/LoadingErrorBlock";

const RecommendationsPageView = () => {
    const {recommsShortData, recommsShortError, recommsShortIsLoading} = useFetchRecommsShort();

    let navigate = useNavigate();
    const goToDetailPage = (id: string) => {
        let path = `${id}`;
        navigate(path);
    }

    const isLoading = recommsShortIsLoading;
    const isError = !!(recommsShortError);
    const SectorsGrid = (
        <div className={styles.recomsGrid}>
            {recommsShortData && recommsShortData.map((rec) => (
                <RecommendationCard
                    key={rec._id}
                    recommendation={rec}
                    handleLinkClick={goToDetailPage}
                />
            ))}
        </div>
    );
    return (
        <>
            <PageHeader
                buttons={<></>}
                isAdmin={false}
                title={"Рекомендации"}
            />
            <LoadingErrorBlock
                isLoading={isLoading}
                isError={isError}
                errorMessage="Ошибка загрузки рекомендаций. Пожалуйста, попробуйте позже."
            />
            {(!isLoading && !isError && recommsShortData !== undefined) && (
                <>{recommsShortData.length > 0 ? SectorsGrid : <p>Актуальных рекомендаций нет</p>}</>
            )}
        </>
    );
};

export default RecommendationsPageView;